import * as React from "react";
import * as yup from "yup";

import { Color, Army } from "./GameState";
import ArmyInput from "./ArmyInput";
import { Button } from "../semantic-ui";
import { Formik, Form } from "../formik";

const armySchema = yup.object().shape({
  army: yup.string().required(),
});

type Props = {
  color: Color;
  onSubmit: (arg0: Army) => void;
};

export default class ArmyForm extends React.Component<Props> {
  handleSubmit = (values: any) => {
    this.props.onSubmit(values.army);
  };

  render() {
    return (
      <Formik
        onSubmit={this.handleSubmit}
        initialValues={{ army: undefined }}
        validationSchema={armySchema}
      >
        <Form>
          <Form.Field
            label={`Choose army for ${this.props.color}.`}
            name="army"
            control={ArmyInput}
            color={this.props.color}
          />
          <Form.Field control={Button} type="submit" primary>
            Choose
          </Form.Field>
        </Form>
      </Formik>
    );
  }
}
